/**
 * D-TAIL LAB — WSG B2C-ONLY Checkout Fix v1.1
 *
 * Problem: WSG (Wholesale Gorilla) hides the native Shopify payment button
 * via CSS (display:none !important) on ALL product pages, including products
 * tagged B2C-ONLY that are excluded from the wholesale catalog.
 * When WSG's checkout button is absent/misconfigured on those products,
 * customers hit a "Parameter Missing or Invalid: items" error.
 *
 * Fix strategy (Option A — tag-driven):
 *   1. Read the WSG exclusion tag list from window.wsgData (live, auto-updated)
 *   2. Compare against the current product's tags (window.ShopifyAnalytics or page JSON)
 *   3. If the product is excluded, restore native Shopify checkout buttons
 *   4. Hardcoded handle list is the last-resort fallback (covers the 13 known B2C products)
 *
 * Safe: only runs on product pages. Never modifies WSG for wholesale customers.
 * Auto-covers future B2C-ONLY tagged products without code changes.
 */
(function () {

  // ── 0. Guard: product pages only ─────────────────────────────────────────
  if (!window.location.pathname.startsWith('/products/')) return;

  // ── 1. Detect exclusion via wsgData (Option A — primary) ─────────────────
  //   wsgData.shop_preferences.exclusions is a WSG-managed array of excluded tags
  //   e.g. ["B2C-ONLY"]. Any product carrying one of those tags is excluded.
  var isExcluded = false;

  try {
    var exclusionTags = (
      window.wsgData &&
      window.wsgData.shop_preferences &&
      Array.isArray(window.wsgData.shop_preferences.exclusions)
    ) ? window.wsgData.shop_preferences.exclusions : ['B2C-ONLY'];

    // 1a. Read product tags from ShopifyAnalytics (most themes, incl. Impact)
    var productTags = [];
    if (
      window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.product
    ) {
      var rawTags = window.ShopifyAnalytics.meta.product.tags;
      // tags can be a comma-separated string or an array depending on theme
      productTags = Array.isArray(rawTags)
        ? rawTags
        : String(rawTags).split(',').map(function (t) { return t.trim(); });
    }

    // 1b. Fallback: window.meta.product (some themes)
    if (productTags.length === 0 && window.meta && window.meta.product) {
      var rawTags2 = window.meta.product.tags;
      productTags = Array.isArray(rawTags2)
        ? rawTags2
        : String(rawTags2).split(',').map(function (t) { return t.trim(); });
    }

    // 1c. Fallback: embedded product JSON in DOM
    if (productTags.length === 0) {
      var jsonEl = document.querySelector(
        'script[type="application/json"][data-product-data], [data-product-json]'
      );
      if (jsonEl) {
        var pData = JSON.parse(jsonEl.textContent || jsonEl.innerText || '{}');
        var rawTags3 = pData.tags;
        productTags = Array.isArray(rawTags3)
          ? rawTags3
          : String(rawTags3 || '').split(',').map(function (t) { return t.trim(); });
      }
    }

    if (productTags.length > 0) {
      isExcluded = productTags.some(function (tag) {
        return exclusionTags.indexOf(tag) !== -1;
      });
    }
  } catch (e) {}

  // ── 2. Last-resort fallback: hardcoded handles (all 13 known B2C products) ─
  if (!isExcluded) {
    var b2cHandles = [
      'arsenal-business-starter-pack',
      'arsenal-cerami-x-pack',
      'arsenal-correction-pack',
      'decon-pack',
      'arsenal-gloss-pack',
      'arsenal-gloss-pack-5-inch-pad-version',
      'd-tail-lab-hero-pack',
      'arsenal-inner-detailing-pack',
      'arsenal-outer-detailing-pack',
      'arsenal-ultimate-pack-4',
      'arsenal-wheel-tire-pack',
      'sample-bundle',
      'nano-ceramic-workshop'
    ];
    var currentHandle = window.location.pathname
      .replace('/products/', '')
      .split('?')[0]
      .split('#')[0];
    isExcluded = b2cHandles.indexOf(currentHandle) !== -1;
  }

  // ── 3. Not a B2C product — leave WSG completely alone ────────────────────
  if (!isExcluded) return;

  // ── 4. Restore native Shopify checkout for B2C products ──────────────────
  function restoreNativeCheckout() {
    // Avoid injecting the style block more than once
    if (document.getElementById('dtaillab-b2c-fix')) return;

    // 4a. CSS override — show native buttons, hide WSG wholesale buttons
    var style = document.createElement('style');
    style.id = 'dtaillab-b2c-fix';
    style.innerHTML = [
      'shopify-payment-button { display: block !important; }',
      '.shopify-payment-button { display: block !important; }',
      '.shopify-payment-button__button { display: block !important; }',
      '.additional-checkout-buttons { display: block !important; }',
      '#wsg-checkout-one { display: none !important; }',
      '.wsg-ws-only { display: none !important; }',
      '.wsg-proxy-container { display: none !important; }'
    ].join('\n');
    document.head.appendChild(style);

    // 4b. DOM: hide WSG's injected checkout button
    var wsgBtn = document.getElementById('wsg-checkout-one');
    if (wsgBtn) wsgBtn.style.display = 'none';

    // 4c. DOM: ensure native Add-to-Cart button is enabled and visible
    var addToCartBtns = document.querySelectorAll(
      'button[name="add"], .product-form__submit'
    );
    addToCartBtns.forEach(function (btn) {
      btn.disabled = false;
      btn.style.display = '';
      btn.style.visibility = 'visible';
      btn.style.opacity = '1';
    });

    // 4d. Re-init Shopify's dynamic checkout (Pay Now / Apple Pay etc.)
    try {
      if (window.Shopify && window.Shopify.PaymentButton) {
        window.Shopify.PaymentButton.init();
      }
    } catch (e) {}
  }

  // Run immediately (before DOMContentLoaded) to catch early WSG injection
  restoreNativeCheckout();

  // Run again at DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreNativeCheckout);
  } else {
    restoreNativeCheckout();
  }

  // Run after WSG's delayed injection (WSG typically runs 200–800ms after DOMContentLoaded)
  setTimeout(restoreNativeCheckout, 600);
  setTimeout(restoreNativeCheckout, 1500);

})();
